import { CardHeader, CardContent, Button, Card, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Snackbar, Backdrop, CircularProgress, Container, Box, Chip } from '@mui/material';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Alert from 'src/components/Alert';
import CalculateIcon from '@mui/icons-material/Calculate';

function SarisFcmCalculate() {

  const [fcmData, setFcmData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    HandleGetFcmCalculator();
  }, []);

  const HandleGetFcmCalculator = () => {
    setLoading(true);
    axios.get(`SetSarisFcmCalculate/`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        setFcmData(data);
        setLoading(false);
        return;
      }).catch((error) => {
        setLoading(false);
        return;
      });
  };

  const fcmCalculator = () => {
    setLoading(true);
    axios.get(`GetSarisFcmCreate/`)
      .then((response) => {
        setLoading(false);
        var data = response.data;
        if (data == 0) {
          setUyariTip('success');
          setresponseMessage("Bu akşam FÇM çalışıcak");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        if (data == 1) {
          setUyariTip('error');
          setresponseMessage("Hata Oluştu !!!");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        if (data == 99) {
          setUyariTip('error');
          setresponseMessage("Hata Oluştu !!!");
          HandleGetFcmCalculator();
          setUyari(true);
          setLoading(false);
          return;
        }
        setLoading(false);
        return;
      }).catch((error) => {
        setLoading(false);
        return;
      });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title="FÇM Hesapla" />
        <Divider />
        <CardContent>
          <Container maxWidth="sm">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Son Hesaplanan Dönem</TableCell>
                    <TableCell align="right">Tarih</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fcmData.length > 0 ? fcmData.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.aciklama}
                      </TableCell>
                      <TableCell align="right">{moment(row.tarih).format('DD/MM/YYYY HH:mm:ss') || '-'}</TableCell>
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        <Chip label="Kayıt bulunamadı" size="small" variant="outlined" />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<CalculateIcon />}
                onClick={() => { fcmCalculator(); }}
              >
                Hesapla
              </Button>
            </Box>
          </Container>
        </CardContent>
      </Card>
    </>
  );

}

export default SarisFcmCalculate;
